import { render } from "./AccordionBlock.vue?vue&type=template&id=42113171"
import script from "./AccordionBlock.vue?vue&type=script&lang=js"
export * from "./AccordionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/AccordionBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42113171"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42113171', __exports__)) {
    api.reload('42113171', __exports__)
  }
  
  module.hot.accept("./AccordionBlock.vue?vue&type=template&id=42113171", () => {
    api.rerender('42113171', render)
  })

}


export default __exports__